// HeaderBanner.jsx
import React from "react";

const HeaderBanner = ({ title, subtitle, logoUrl, category }) => {
  return (
    <div className="relative bg-[#111827] py-16 text-white">
      <div className="container px-4 md:px-6">
        <div className="mx-auto max-w-4xl">
          <div className="flex flex-col items-center gap-6 md:flex-row md:items-center md:gap-8">
            <div
              className={`text-center md:text-left ${!logoUrl ? "mx-auto md:mx-0" : ""}`}
            >
              <h1 className="text-3xl font-bold tracking-tight text-white md:text-4xl lg:text-5xl">
                {title}
              </h1>
              <p className="mt-4 text-lg text-primary">{subtitle}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderBanner;
